// Angular
import { Injectable } from '@angular/core';

// Third party
import { Observable } from 'rxjs';

// Local library
import {
  IAccountPreferencesModel,
  IBaseResponseSlim,
  IToteConfigurationCallResponse,
  IUpsertIPAccessRequest,
  IUsertPreferencesFieldRequest
} from '@amwager/util-ts';

// Local file
import { HttpService } from '../services';



// TODO: write tests
@Injectable()
export class ToteConfigurationAPIService {
  private readonly API_URL = '/api/ToteConfiguration';

  constructor(
    private readonly httpService: HttpService,
  ) {}

  /**
   * GET API
   */

  /**
   * @description
   * Get Loss Limits for a customer.
   *
   * @returns Observable<{}>
   */
  // eslint-disable-next-line @typescript-eslint/ban-types
  lossLimit$(): Observable<{}> {
    return this.httpService.get$({
      api: `${this.API_URL}/LossLimit`,
    });
  }

  /**
   * @description
   * Get the Tote configuration details.
   *
   * @returns Observable<IToteConfigurationCallResponse>
   */
  getToteConfiguration$(): Observable<IToteConfigurationCallResponse> {
    return this.httpService.get$({
      api: `${this.API_URL}/GetToteConfiguration`,
    });
  }


  /**
   * POST API
   */

  // /**
  //  * @description
  //  * Set customer Loss Limits
  //  *
  //  * @param dailyLossLimit string
  //  * @returns Observable<{}>
  //  */
  // // eslint-disable-next-line @typescript-eslint/ban-types
  // lossLimitPost$(dailyLossLimit: string): Observable<{}> {
  //   return this.httpService.get$({
  //     api: `${this.API_URL}/LossLimit`,
  //     params: this.httpService.objToHttpParams({
  //       dailyLossLimit
  //     })
  //   });
  // }

  /**
   * @description
   * Set customer Loss Limits
   *
   * @param dailyLossLimit string
   * @returns Observable<{}>
   */
  // eslint-disable-next-line @typescript-eslint/ban-types
  lossLimitPost$(dailyLossLimit: string): Observable<{}> {
    return this.httpService.post$({
      api: `${this.API_URL}/LossLimit?dailyLossLimit=${dailyLossLimit}`,
    });
  }

  /**
   * @description
   * Upsert account preferences
   *
   * @param accountPreferencesModel IAccountPreferencesModel
   * @returns Observable<IBaseResponseSlim>
   */
  upsertAccountPrefences$(accountPreferencesModel: IAccountPreferencesModel)
    : Observable<IBaseResponseSlim> {
    return this.httpService.post$({
      api: `${this.API_URL}/UpsertAccountPrefences`,
      body: accountPreferencesModel
    });
  }

  /**
   * @description
   * Add or replace ip restriction.
   *
   * @param upsertIPAccessRequest IUpsertIPAccessRequest
   * @returns Observable<IBaseResponseSlim>
   */
  upsertIPAccessRights$(upsertIPAccessRequest: IUpsertIPAccessRequest)
    : Observable<IBaseResponseSlim> {
    return this.httpService.post$({
      api: `${this.API_URL}/UpsertIPAccessRights`,
      body: upsertIPAccessRequest
    });
  }

  /**
   * @description
   * Update specific account preferences filed
   *
   * @param usertPreferencesFieldRequest IUsertPreferencesFieldRequest
   * @returns Observable<IBaseResponseSlim>
   */
  upsertAccountPrefencesField$(
    usertPreferencesFieldRequest: IUsertPreferencesFieldRequest
  ): Observable<IBaseResponseSlim> {
    return this.httpService.post$({
      api: `${this.API_URL}/UpsertAccountPrefencesField`,
      body: usertPreferencesFieldRequest
    });
  }

}
